import React from 'react';

export default function SchedulePromotion() {
  return (
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Scheduling_a_Promotion__IyzSUomRRNG0fEDekLavkg"
      height="640"
      title="Schedule Promotion"
      allowFullScreen
    />
  );
}
